import { apiFetch } from "../utils/apiFetch";

const apiUrl = process.env.REACT_APP_API_URL;

// Fetch list of all Lesson Plans
export async function getAllLessonPlans() {
  const response = await apiFetch(`${apiUrl}/lesson-plans`, {
    method: 'GET',
  });
  if (!response.ok) throw new Error('Failed to fetch lesson plans');
  return await response.json();
}

// Fetch details of a specific Lesson Plan (with Sessions and Videos)
export async function getLessonPlanDetails(lessonPlanId) {
  const response = await apiFetch(`${apiUrl}/lesson-session-videos/${lessonPlanId}`, {
    method: 'GET',
  });
  if (!response.ok) throw new Error('Failed to fetch lesson plan details');
  return await response.json();
}
